/* EVIAL Creatine landing, SHOP version · assets/evial-landing-shop.js
   Loaded only by layout/evial-shop.liquid (defer). Global size + purchase-option state, add-to-cart forms,
   analytics, dots, chart. Variant ids, prices and the subscription plan come from window.EVIAL_SHOP,
   written by sections/evial-landing-shop.liquid (Liquid) before this file runs. No Amazon URLs here. */
/* =========================================================================
   1. CONFIG. Static copy per size; variant ids and prices are merged in
   from window.EVIAL_SHOP (set by the section's Liquid).
   ========================================================================= */
window.EVIAL_PRODUCTS = {
  "60":  { servings: 60,  grams: 300, oz: "10.58 oz",         ozShort: "10.58 oz", label: "60 servings",  lasts: "about 2 months",     lastsQ: "about",     lastsN: "2 months" },
  "100": { servings: 100, grams: 500, oz: "17.64 oz (1.1 lb)", ozShort: "17.64 oz", label: "100 servings", lasts: "just over 3 months", lastsQ: "just over", lastsN: "3 months" },
  "200": { servings: 200, grams: 1000, oz: "35.27 oz (2.2 lb)", ozShort: "35.27 oz", label: "2 × 100 servings", lasts: "about 6 months", lastsQ: "about", lastsN: "6 months", jar: "100", bundle: true }
};
window.EVIAL_SHOP = window.EVIAL_SHOP || { hasPlan: false, variants: {}, plans: [] };
(function () {
  for (var k in window.EVIAL_PRODUCTS) {
    var v = window.EVIAL_SHOP.variants[k];
    if (!v) { delete window.EVIAL_PRODUCTS[k]; continue; }  // e.g. no bundle variant in the store
    window.EVIAL_PRODUCTS[k].variantId = v.id; window.EVIAL_PRODUCTS[k].available = v.available !== false;
    window.EVIAL_PRODUCTS[k].price = v.price; window.EVIAL_PRODUCTS[k].priceText = v.priceText; window.EVIAL_PRODUCTS[k].perServingText = v.perServingText;
    window.EVIAL_PRODUCTS[k].plans = v.plans || {}; window.EVIAL_PRODUCTS[k].compareText = v.compareText || "";
  }
})();
window.EVIAL_CONFIG = {
  defaultSize: "100",            // A/B test candidate: "60" vs "100"
  sizeParam: "size",             // ?size=60 preselects a size (useful per ad)
  rating: { value: 4.8, count: 40, asOf: "October 7, 2026" }
};
(function () {
  "use strict";
  var P = window.EVIAL_PRODUCTS, C = window.EVIAL_CONFIG, S = window.EVIAL_SHOP;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var NS = "http://www.w3.org/2000/svg";
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- 2. Analytics: vendor-neutral. Pushes to dataLayer if present. ---------- */
  window.dataLayer = window.dataLayer || [];
  window.evialEvents = window.evialEvents || [];
  function track(name, detail) {
    var ev = Object.assign({ event: "evial_" + name }, detail || {});
    window.evialEvents.push(ev);
    try { window.dataLayer.push(ev); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent("evial:track", { detail: ev })); } catch (e) {}
  }
  window.evialTrack = track;

  /* ---------- 3. State ---------- */
  function initialSize() {
    try {
      var q = new URLSearchParams(window.location.search).get(C.sizeParam);
      if (q && P[q]) return q;
    } catch (e) {}
    return P[C.defaultSize] ? C.defaultSize : "100";
  }
  var state = { size: initialSize(), plan: "" };   // plan: "" = one-time, otherwise a selling plan id
  var ORDER = ["100", "200", "60"].filter(function (k) { return !!P[k]; });
  function otherSize(s) { var i = ORDER.indexOf(s); return ORDER[(i + 1) % ORDER.length]; }   // sticky swap cycles through the sizes
  function bind(key, val) { $$('[data-bind="' + key + '"]').forEach(function (el) { el.textContent = val; }); }

  function render() {
    var p = P[state.size];
    $$('input[name="size-hero"]').forEach(function (r) { r.checked = (r.value === state.size); });
    var planPrice = function (q) { var pl = state.plan && q.plans[state.plan]; return pl || { priceText: q.priceText, perServingText: q.perServingText }; };
    $$('[data-cta="selected"]').forEach(function (a) {
      a.setAttribute("data-size", state.size);
      a.disabled = !p.available;
      var tpl = a.getAttribute("data-label"), l = $("[data-cta-label]", a);
      if (tpl && l) l.textContent = p.available ? tpl.replace("{n}", String(p.servings)) : "Sold out";
    });
    // Forms: the "selected" ones follow the global size; per-size forms keep their own variant. All follow the purchase option.
    $$("form[data-buyform]").forEach(function (f) {
      var btn = $("button[type=submit]", f), fixed = btn && btn.getAttribute("data-cta-size");
      var q = fixed ? P[fixed] : p, idIn = $("[data-form-id]", f), plIn = $("[data-form-plan]", f);
      if (idIn && q.variantId) idIn.value = q.variantId;
      if (plIn) { plIn.disabled = !state.plan; plIn.value = state.plan || ""; }
      if (fixed && btn) btn.disabled = !q.available;
    });
    var pp = planPrice(p);
    bind("ctaPrice", pp.priceText || "");
    bind("priceOnce", p.priceText || ""); bind("perOnce", (p.perServingText || "") + " per serving");
    var sub = S.planDefault && p.plans[state.plan || S.planDefault];
    if (sub) { bind("priceSub", sub.priceText); bind("perSub", sub.perServingText + " per serving"); }
    var cur = (S.plans || []).filter(function (x) { return String(x.id) === String(state.plan); })[0];
    if (cur) { bind("planName", cur.name); bind("planPct", String(cur.pct)); }
    var fq = $("[data-plan-freq]"); if (fq) fq.hidden = !state.plan;
    ORDER.forEach(function (k) {
      var q = P[k], t = planPrice(q);
      var cmp = (state.plan && q.plans[state.plan]) ? q.priceText : q.compareText;   // subscription: strike the one-time price
      $$('[data-price-size="' + k + '"]').forEach(function (el) { el.textContent = t.priceText || ""; });
      $$('[data-per-size="' + k + '"]').forEach(function (el) { el.textContent = (t.perServingText || "") + " per serving"; });
      $$('[data-compare-size="' + k + '"]').forEach(function (el) { el.textContent = cmp || ""; el.hidden = !cmp; });
    });
    var jarKey = p.jar || state.size;   // the bundle shows the 100-serving jar
    $$(".jar").forEach(function (img) { img.classList.toggle("is-active", img.getAttribute("data-jar") === jarKey); });
    var jb = $(".hero__jarbox"); if (jb) jb.setAttribute("data-size", jarKey);
    $$("[data-sizecard-hero]").forEach(function (c) { c.classList.toggle("is-selected", c.getAttribute("data-sizecard-hero") === state.size); });
    $$("[data-sizecard]").forEach(function (c) {
      var on = c.getAttribute("data-sizecard") === state.size;
      c.classList.toggle("is-selected", on);
      if (c.tagName === "BUTTON") c.setAttribute("aria-pressed", String(on));
    });
    var sw = $("[data-swap-size]");
    if (sw) sw.setAttribute("aria-label", "Switch to " + P[otherSize(state.size)].servings + " servings");
    $$("[data-pick-size]").forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-pick-size") === state.size)); });
    // Hero callouts describe the selected jar (same global state as every CTA)
    bind("coServ", String(p.servings));
    bind("coGrams", p.grams + " g");
    bind("coOz", p.ozShort);
    bind("coLastQ", p.lastsQ);
    bind("coLast", p.lastsN);
    bind("stickyName", p.label);
    bind("stickyGrams", p.grams + " g");
    bind("stickySwapN", String(P[otherSize(state.size)].servings));
  }

  function setSize(size, location) {
    if (!P[size]) return;
    var changed = size !== state.size;
    state.size = size;
    render();
    if (changed) track("size_select", { size: size, variant_id: P[size].variantId, location: location });
  }
  function setPlan(planId, location) {
    var changed = String(planId || "") !== String(state.plan || "");
    state.plan = planId || "";
    render();
    if (changed) track("plan_select", { plan_id: state.plan || null, option: state.plan ? "subscription" : "one_time", location: location });
  }

  /* ---------- 4. Wiring ---------- */
  $$('input[name="size-hero"]').forEach(function (r) {
    r.addEventListener("change", function () { if (r.checked) setSize(r.value, "hero"); });
  });
  $$("[data-pick-size]").forEach(function (b) {
    b.addEventListener("click", function () { setSize(b.getAttribute("data-pick-size"), "final_cta"); });
  });
  $$("[data-sizecard]").forEach(function (card) {
    card.addEventListener("click", function (e) {
      if (e.target.closest("form")) return; // the option's own CTA adds that size to the cart
      setSize(card.getAttribute("data-sizecard"), "size_section");
    });
  });
  var swap = $("[data-swap-size]");
  if (swap) swap.addEventListener("click", function () { setSize(otherSize(state.size), "sticky"); });

  // Purchase option: one-time vs subscription (only rendered when the product has a selling plan)
  $$('input[name="plan-hero"]').forEach(function (r) {
    r.addEventListener("change", function () {
      if (!r.checked) return;
      var sel = $("[data-plan-select]");
      setPlan(r.value ? (sel ? sel.value : r.value) : "", "hero");
    });
  });
  var planSel = $("[data-plan-select]");
  if (planSel) planSel.addEventListener("change", function () { if (state.plan) setPlan(planSel.value, "hero_frequency"); });

  /* ---------- Buy: clear cart, POST /cart/add.js, then go straight to /checkout ---------- */
  function addToCart(form) {
    var btn = $("button[type=submit]", form), size = btn ? btn.getAttribute("data-size") : state.size;
    var idIn = $("[data-form-id]", form), plIn = $("[data-form-plan]", form);
    var item = { id: Number(idIn.value), quantity: 1 };
    if (plIn && !plIn.disabled && plIn.value) item.selling_plan = Number(plIn.value);
    track("add_to_cart", { variant_id: item.id, size: size, selling_plan: item.selling_plan || null, location: form.getAttribute("data-track-loc") });
    if (btn) { btn.classList.add("is-busy"); btn.setAttribute("aria-busy", "true"); }
    // Landing = one decision: clear whatever is in the cart, add the chosen jar, go straight to checkout (no cart page).
    return fetch("/cart/clear.js", { method: "POST", headers: { "Accept": "application/json" } })
      .catch(function () {})
      .then(function () { return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ items: [item] }) }); })
      .then(function (r) { if (!r.ok) throw new Error("add failed " + r.status); return r.json(); })
      .then(function () { window.location.href = "/checkout"; })
      .catch(function (err) {
        track("add_to_cart_error", { message: String(err && err.message) });
        if (btn) { btn.classList.remove("is-busy"); btn.removeAttribute("aria-busy"); }
        form.submit(); // plain POST /cart/add with return_to=/checkout
      });
  }
  $$("form[data-buyform]").forEach(function (f) {
    f.addEventListener("submit", function (e) { e.preventDefault(); addToCart(f); });
  });
  var stickyBuy = $("[data-sticky-buy]");
  if (stickyBuy) stickyBuy.addEventListener("click", function () { var f = $("#hero-cta") && $("#hero-cta").closest("form"); if (f) addToCart(f); });

  // Header "Choose your size" goes to the full size section (#sizes), not an Amazon link.
  // Lands with the section heading just under the sticky header (skips the section's top padding).
  $$("[data-scroll-to]").forEach(function (a) {
    a.addEventListener("click", function (e) {
      var t = document.getElementById(a.getAttribute("data-scroll-to"));
      if (!t) return;
      e.preventDefault();
      var hdr = $(".hdr"), hh = hdr ? hdr.getBoundingClientRect().height : 0;
      var pad = parseFloat(window.getComputedStyle(t).paddingTop) || 0;
      var y = t.getBoundingClientRect().top + window.pageYOffset + pad - hh - 24;
      try { window.scrollTo({ top: Math.max(0, y), behavior: reduce ? "auto" : "smooth" }); } catch (err) { window.scrollTo(0, Math.max(0, y)); }
      try { t.focus({ preventScroll: true }); } catch (err) {}
      track("header_cta", { location: "header", target: a.getAttribute("data-track-target") || t.id });
    });
  });

  // Outbound click to the Amazon review page (rating section only)
  document.addEventListener("click", function (e) {
    var a = e.target.closest('a[data-track="amazon_reviews_click"]');
    if (a) track("amazon_reviews_click", { location: a.getAttribute("data-track-loc"), destination_url: a.href });
  });

  // FAQ opens
  $$("details[data-faq]").forEach(function (d) {
    d.addEventListener("toggle", function () { if (d.open) track("faq_open", { question: d.getAttribute("data-faq") }); });
  });

  // Section views (once each)
  if ("IntersectionObserver" in window) {
    var seen = {};
    var so = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var id = en.target.getAttribute("data-section");
        if (en.isIntersecting && !seen[id]) { seen[id] = true; track("section_view", { section: id }); so.unobserve(en.target); }
      });
    }, { threshold: 0.35 });
    $$("[data-section]").forEach(function (s) { so.observe(s); });
  }

  /* ---------- 5. Sticky bar (mobile): on after the hero CTA scrolls away, off at the final CTA ---------- */
  var sticky = $("#sticky"), heroCta = $("#hero-cta"), finalSec = $("#final");
  if (sticky && heroCta) {
    var stickyOn = null, ticking = false;
    function upd() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var heroOut = heroCta.getBoundingClientRect().bottom < 0;
      var finalIn = false;
      if (finalSec) { var f = finalSec.getBoundingClientRect(); finalIn = f.top < vh - Math.min(f.height, vh) * 0.2 && f.bottom > 0; }
      var on = heroOut && !finalIn;
      if (on === stickyOn) return;
      stickyOn = on;
      sticky.classList.toggle("is-on", on);
      sticky.setAttribute("aria-hidden", String(!on));
      $$("a, button", sticky).forEach(function (el) { el.tabIndex = on ? 0 : -1; });
    }
    function req() { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }
    window.addEventListener("scroll", req, { passive: true });
    window.addEventListener("resize", req);
    upd();
  }

  /* ---------- 6. Stars + reviews ---------- */
  var STAR = "M10 1.6l2.5 5.3 5.8.7-4.3 4 1.1 5.7L10 14.5 4.9 17.3 6 11.6 1.7 7.6l5.8-.7z";
  function starsSvg(filled, on, off) {
    var s = '<svg viewBox="0 0 110 20" aria-hidden="true">';
    for (var i = 0; i < 5; i++) s += '<path transform="translate(' + (i * 22.5) + ' 0)" d="' + STAR + '" fill="' + (i < filled ? (on || "#111110") : (off || "#CFCCC4")) + '"/>';
    return s + "</svg>";
  }
  $$("[data-stars]").forEach(function (el) {
    var on = el.getAttribute("data-stars-on"), off = el.getAttribute("data-stars-off");
    el.innerHTML = starsSvg(0, on, off) + '<span class="stars__fill" style="width:' + (C.rating.value / 5 * 100).toFixed(1) + '%">' + starsSvg(5, on, off) + "</span>";
  });
  bind("rating", C.rating.value.toFixed(1));
  bind("ratingCount", String(C.rating.count));

  /* ---------- 7. EVIAL dot fields: the jar's radial halftone, redrawn ----------
     One <path> per field (cheap to render). Dots grow outward and are larger on
     one side, like the perspective "tunnel" printed on the pack. */
  var DOTS = {
    hero:  { cx: 500, cy: 500, r0: 110, r1: 500, rings: 15, s0: 1.4, s1: 8.5, gap: 1.75, skewA: 0, fill: "#D8D3C8", accents: [[11, -0.9], [7, 0.55]] },
    dark:  { cx: 500, cy: 500, r0: 80,  r1: 500, rings: 16, s0: 1.2, s1: 9,   gap: 1.7,  skewA: Math.PI * 0.85, fill: "#2A2A28", accents: [] },
    final: { cx: 500, cy: 500, r0: 90,  r1: 500, rings: 16, s0: 1.2, s1: 8.5, gap: 1.75, skewA: Math.PI * 1.1, fill: "#D8D3C8", accents: [] }
  };
  function ringPoint(p, i, a) {
    var t = i / (p.rings - 1), rr = p.r0 + (p.r1 - p.r0) * Math.pow(t, 1.1);
    return [p.cx + Math.cos(a) * rr, p.cy + Math.sin(a) * rr, t];
  }
  function dotField(svg) {
    var p = DOTS[svg.getAttribute("data-dots")]; if (!p) return;
    var d = [];
    for (var i = 0; i < p.rings; i++) {
      var t = i / (p.rings - 1), rr = p.r0 + (p.r1 - p.r0) * Math.pow(t, 1.1);
      var base = p.s0 + (p.s1 - p.s0) * Math.pow(t, 1.45);
      var n = Math.max(12, Math.round((2 * Math.PI * rr) / (base * 2 * p.gap)));
      var off = (i % 2) * Math.PI / n;
      for (var k = 0; k < n; k++) {
        var a = off + (k / n) * Math.PI * 2;
        var m = 0.3 + 0.7 * (1 + Math.cos(a - p.skewA)) / 2;
        var r = base * m; if (r < 0.7) continue;
        var x = p.cx + Math.cos(a) * rr, y = p.cy + Math.sin(a) * rr;
        d.push("M" + (x - r).toFixed(1) + " " + y.toFixed(1) + "a" + r.toFixed(1) + " " + r.toFixed(1) + " 0 1 0 " + (2 * r).toFixed(1) + " 0a" + r.toFixed(1) + " " + r.toFixed(1) + " 0 1 0 " + (-2 * r).toFixed(1) + " 0");
      }
    }
    var path = document.createElementNS(NS, "path");
    path.setAttribute("d", d.join("")); path.setAttribute("fill", p.fill);
    svg.appendChild(path);
    (p.accents || []).forEach(function (ac) {
      var pt = ringPoint(p, ac[0], ac[1]), c = document.createElementNS(NS, "circle");
      c.setAttribute("cx", pt[0].toFixed(1)); c.setAttribute("cy", pt[1].toFixed(1)); c.setAttribute("r", (p.s0 + (p.s1 - p.s0) * Math.pow(pt[2], 1.45)).toFixed(1));
      c.setAttribute("fill", "#B5562F"); svg.appendChild(c);
    });
  }
  $$("svg[data-dots]").forEach(dotField);

  // Dot line (statement → science transition): dots shrinking left to right
  $$("[data-dotline]").forEach(function (el) {
    var n = window.innerWidth < 640 ? 14 : 28, h = "";
    for (var i = 0; i < n; i++) { var s = (1.15 - 0.95 * (i / (n - 1))); h += '<i style="--s:' + s.toFixed(2) + 'rem"></i>'; }
    el.innerHTML = h;
  });

  // Routine marks
  function circ(svg, x, y, r, fill) { var c = document.createElementNS(NS, "circle"); c.setAttribute("cx", x.toFixed(1)); c.setAttribute("cy", y.toFixed(1)); c.setAttribute("r", r.toFixed(2)); c.setAttribute("fill", fill); svg.appendChild(c); }
  var INK = "#111110", TERRA = "#B5562F";
  $$("svg[data-art]").forEach(function (svg) {
    var kind = svg.getAttribute("data-art"), i, k;
    if (kind === "scoop") {             // one scoop: a single full dot inside a ring of small dots
      circ(svg, 80, 80, 30, INK);
      for (k = 0; k < 24; k++) { var a = k / 24 * Math.PI * 2; circ(svg, 80 + Math.cos(a) * 54, 80 + Math.sin(a) * 54, 2.6, INK); }
      circ(svg, 80, 26, 5, TERRA);
    } else if (kind === "stir") {        // stirring: dots on a spiral, growing outward
      for (i = 0; i < 46; i++) { var ang = i * 0.42, rad = 6 + i * 1.55; circ(svg, 80 + Math.cos(ang) * rad, 80 + Math.sin(ang) * rad, 1.2 + i * 0.09, i === 45 ? TERRA : INK); }
    } else if (kind === "repeat") {      // repeat: four weeks of daily scoops
      for (i = 0; i < 4; i++) for (k = 0; k < 7; k++) circ(svg, 20 + k * 20, 50 + i * 20, 6, (i === 3 && k === 6) ? TERRA : INK);
    }
  });

  /* ---------- 8. AstraGin ratio: 100 dots of creatine + 1 of AstraGin ---------- */
  var grid = $("[data-ratio-grid]"), ratio = $("[data-ratio]");
  if (grid) {
    var h = "";
    for (var r = 0; r < 10; r++) for (var c = 0; c < 10; c++) h += '<i style="--d:' + ((r + c) * 48) + '"></i>';
    grid.innerHTML = h;
  }
  function onceVisible(el, fn, threshold) {
    if (!el) return;
    if (reduce || !("IntersectionObserver" in window)) { fn(); return; }
    var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { fn(); io.disconnect(); } }, { threshold: threshold || 0.35 });
    io.observe(el);
  }
  onceVisible(ratio, function () { ratio.classList.add("is-on"); }, 0.25);

  /* ---------- 9. Saturation illustration (schematic) ----------
     Drawn in real pixels for the current width, so labels stay 13px on phones. */
  var svg = $('svg[data-chart="saturation"]'), chartFig = svg ? svg.closest(".chart") : null;
  function daily(d) { return 1 - Math.exp(-d / 8); }                                          // illustrative curve
  function loading(d) { return d <= 5 ? 1 - Math.exp(-d / 1.7) : Math.max(0.95, daily(d)); }  // illustrative curve
  function drawChart() {
    if (!svg) return;
    var W = Math.max(280, Math.round(svg.parentNode.clientWidth));
    var narrow = W < 560;
    var H = narrow ? 260 : Math.max(320, Math.min(440, Math.round(W * 0.46))), days = 28;
    var x0 = narrow ? 46 : 60, x1 = W - 8, yTop = 18, yBot = H - 40;
    function X(d) { return x0 + (d / days) * (x1 - x0); }
    function Y(v) { return yBot - v * (yBot - yTop); }
    svg.setAttribute("viewBox", "0 0 " + W + " " + H);
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    function el(tag, attrs, txt) { var e = document.createElementNS(NS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); if (txt) e.textContent = txt; svg.appendChild(e); return e; }
    el("line", { x1: x0, x2: x1, y1: Y(1).toFixed(1), y2: Y(1).toFixed(1), stroke: "rgba(242,241,236,.2)", "stroke-width": 1, "stroke-dasharray": "2 5" });
    el("line", { x1: x0, x2: x1, y1: Y(.5).toFixed(1), y2: Y(.5).toFixed(1), stroke: "rgba(242,241,236,.1)", "stroke-width": 1 });
    [7, 14, 21].forEach(function (d) { el("line", { x1: X(d).toFixed(1), x2: X(d).toFixed(1), y1: yTop, y2: yBot, stroke: "rgba(242,241,236,.07)", "stroke-width": 1 }); });
    el("line", { x1: x0, x2: x1, y1: Y(0).toFixed(1), y2: Y(0).toFixed(1), stroke: "rgba(242,241,236,.55)", "stroke-width": 1 });
    var dPts = [], lPts = [];
    for (var s = 0; s <= days * 4; s++) { var d = s / 4; dPts.push(X(d).toFixed(1) + "," + Y(daily(d)).toFixed(1)); lPts.push(X(d).toFixed(1) + "," + Y(loading(d)).toFixed(1)); }
    el("path", { d: "M" + X(0).toFixed(1) + "," + Y(0).toFixed(1) + " L" + dPts.join(" L") + " L" + X(days).toFixed(1) + "," + Y(0).toFixed(1) + " Z", fill: "rgba(227,148,112,.1)" });
    el("path", { d: "M" + lPts.join(" L"), fill: "none", stroke: "#A9A8A2", "stroke-width": 1.5, "stroke-dasharray": "5 6", "stroke-linecap": "round" });
    el("path", { "class": "ln-daily", d: "M" + dPts.join(" L"), fill: "none", stroke: "#E39470", "stroke-width": 2.5, "stroke-linejoin": "round", "stroke-linecap": "round", pathLength: 1 });
    for (var k2 = 1; k2 <= days; k2++) {
      var big = k2 % 7 === 0;
      var dot = el("circle", { "class": "day-dot", cx: X(k2).toFixed(1), cy: Y(daily(k2)).toFixed(1), r: big ? 5 : (narrow ? 2.2 : 3), fill: big ? "#E39470" : "#141414", stroke: "#E39470", "stroke-width": big ? 0 : 1.5 });
      dot.style.setProperty("--k", k2);
    }
    var lab = { fill: "#A9A8A2", "font-size": 13, "font-family": "Alexandria, Helvetica, Arial, sans-serif" };
    if (!narrow) {
      el("text", Object.assign({ "class": "note", x: X(5.6).toFixed(1), y: (Y(0.95) - 12).toFixed(1) }, lab), "Optional loading: about a week");
      el("text", Object.assign({ "class": "note", x: X(days).toFixed(1), y: (Y(daily(24)) + 34).toFixed(1), "text-anchor": "end", fill: "#E39470" }, { "font-size": 13, "font-family": lab["font-family"] }), "One scoop a day: about 3–4 weeks");
    }
    var ticks = narrow ? [[0, "Day 1"], [14, "Week 2"], [28, "Week 4"]] : [[0, "Day 1"], [7, "Week 1"], [14, "Week 2"], [21, "Week 3"], [28, "Week 4"]];
    ticks.forEach(function (t) { el("text", Object.assign({ x: X(t[0]).toFixed(1), y: H - 12, "text-anchor": t[0] === 0 ? "start" : (t[0] === days ? "end" : "middle") }, lab), t[1]); });
    el("text", Object.assign({ x: 0, y: (Y(1) + 4).toFixed(1) }, lab), "Full");
    el("text", Object.assign({ x: 0, y: (Y(0) + 4).toFixed(1) }, lab), "Start");
  }
  drawChart();
  onceVisible(chartFig, function () { chartFig.classList.add("is-drawn"); }, 0.35);
  var ct, lastW = window.innerWidth;
  window.addEventListener("resize", function () { clearTimeout(ct); ct = setTimeout(function () { if (Math.abs(window.innerWidth - lastW) > 2) { lastW = window.innerWidth; drawChart(); } }, 150); });

  /* Hero dot field follows the jar (offset math ignores the entrance transform) */
  var heroEl = $(".hero"), jarbox = $(".hero__jarbox"), heroDots = $(".hero__dots");
  function placeField() {
    if (!heroEl || !jarbox || !heroDots) return;
    var x = 0, y = 0, el = jarbox;
    while (el && el !== heroEl) { x += el.offsetLeft; y += el.offsetTop; el = el.offsetParent; }
    var w = jarbox.offsetWidth, h = jarbox.offsetHeight, wide = window.innerWidth >= 980;
    heroDots.style.setProperty("--fx", (x + w * (wide ? 0.66 : 0.6)) + "px");
    heroDots.style.setProperty("--fy", (y + h * (wide ? 0.36 : 0.46)) + "px");
    heroDots.style.setProperty("--fs", (w * (wide ? 2.5 : 2.1)) + "px");
  }
  placeField();
  window.addEventListener("resize", function () { requestAnimationFrame(placeField); });
  window.addEventListener("load", placeField);

  /* ---------- 10. Hero entrance (once) ---------- */
  var hero = $(".hero");
  if (hero) requestAnimationFrame(function () { requestAnimationFrame(function () { hero.classList.add("is-in"); }); });

  render();
})();
